export default "__VITE_ASSET__Bnh7fyu6__"